"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doc = void 0;
exports.doc = $(document);
